import React from 'react'
import { Bar } from 'react-chartjs-2'
import styled from 'styled-components';
import i18n from '../i18n';
import { Card, CardTitle, CardBody } from '../styled/Card';

const placeData = (data) => {
  const { children, teenagers, young_adults, adults, mature, seniors } = data;

  return ({
    labels: [
      i18n.t('clientsDemography.children'),
      i18n.t('clientsDemography.teenagers'),
      i18n.t('clientsDemography.youngAdults'),
      i18n.t('clientsDemography.adults'),
      i18n.t('clientsDemography.mature'),
      i18n.t('clientsDemography.seniors')
    ],
    datasets: [
      {
        data: [
          children?.raw_count_male || 0,
          teenagers?.raw_count_male || 0,
          young_adults?.raw_count_male || 0,
          adults?.raw_count_male || 0,
          mature?.raw_count_male || 0,
          seniors?.raw_count_male || 0,
        ],
        label: i18n.t('male'),
        backgroundColor: 'rgba(157,215,231,0.7)',
        borderColor: 'rgba(157,215,231, 1)',
      },
      {
        data: [
          children?.raw_count_female || 0,
          teenagers?.raw_count_female || 0,
          young_adults?.raw_count_female || 0,
          adults?.raw_count_female || 0,
          mature?.raw_count_female || 0,
          seniors?.raw_count_female || 0,
        ],
        label: i18n.t('female'),
        backgroundColor: 'rgba(0,185,127,0.7)',
        borderColor: 'rgba(0,185,127,1)',
      },
      {
        data: [
          children?.raw_count_non_binary || 0,
          teenagers?.raw_count_non_binary || 0,
          young_adults?.raw_count_non_binary || 0,
          adults?.raw_count_non_binary || 0,
          mature?.raw_count_non_binary || 0,
          seniors?.raw_count_non_binary || 0,
        ],
        label: i18n.t('non_binary'),
        backgroundColor: 'rgba(105,164,219,0.7)',
        borderColor: 'rgba(105,164,219,1)',
      },
      {
        data: [
          children?.raw_count_not_specified || 0,
          teenagers?.raw_count_not_specified || 0,
          young_adults?.raw_count_not_specified || 0,
          adults?.raw_count_not_specified || 0,
          mature?.raw_count_not_specified || 0,
          seniors?.raw_count_not_specified || 0,
        ],
        label: i18n.t('n_a'),
        backgroundColor: 'rgba(160,160,160,0.7)',
        borderColor: 'rgba(160,160,160,1)',
      },
    ],
  })
};

const ClientsGender = (props) => {
  const { clients_demography } = props.data;

  return (
    <Card>
      <CardTitle>{i18n.t('clientsGender.title')}</CardTitle>
      <CardBody padding={'20px 30px'}>
        <Bar
          data={placeData(clients_demography || {})}
          options={
            {
              barValueSpacing: 20,
              scales: {
                yAxes: [{
                  ticks: { min: 0 }
                }]
              }
            }
          }
        />
      </CardBody>
    </Card>
  )
};

export default ClientsGender;

const Header = styled.div`
  text-align: center;
`;
